import { Button, TextInput } from '@mantine/core';
import { FileWithPath } from '@mantine/dropzone';
import { useForm, zodResolver } from '@mantine/form';
import { notifications } from '@mantine/notifications';

import { useDirtyForm } from '@/shared/hooks/use-dirty-form';
import { SelectFileInput } from '@/widgets/select-file-input';

import {
  useCreateCategoryMutation,
  useUploadCategoryPreviewMutation,
} from '../model/create-category-page.cases';
import { CREATE_CATEGORY_SCHEMA } from '../model/create-category-page.schemas';
import styles from './create-category-page.module.scss';

const CreateCategoryPage = () => {
  const form = useForm({
    initialValues: {
      title: '',
      previewFile: null as FileWithPath | null,
    },
    validate: zodResolver(CREATE_CATEGORY_SCHEMA),
  });
  const createCategoryMutation = useCreateCategoryMutation();
  const uploadCategoryPreviewMutation = useUploadCategoryPreviewMutation();
  useDirtyForm(form.isDirty());

  async function handleSubmit(values: {
    title: string;
    previewFile: FileWithPath | null;
  }) {
    if (!values.previewFile) return;

    const imageUrl = await uploadCategoryPreviewMutation
      .mutateAsync(values.previewFile)
      .catch((e) => {
        notifications.show({
          message: 'Не удалось загрузить изображение',
          color: 'red',
        });

        throw e;
      });

    createCategoryMutation
      .mutateAsync({
        title: values.title,
        imgUrl: imageUrl,
      })
      .then((result) => {
        history.back();
        notifications.show({
          message: 'Категория создана',
          color: 'green',
        });

        return result;
      })
      .catch(() => {
        notifications.show({
          message: 'Не удалось создать категорию',
          color: 'red',
        });
      });
  }

  return (
    <form className={styles.container} onSubmit={form.onSubmit(handleSubmit)}>
      <p className={styles.title}>Создание категории</p>
      <TextInput
        placeholder="Название категории"
        label="Название"
        className={styles.nameInput}
        {...form.getInputProps('title')}
      />
      <SelectFileInput
        onDrop={(files) => form.setFieldValue('previewFile', files[0])}
        label="Обложка"
        description={`Допустимые форматы файлов: png
          Размер файла не должен превышать 400 кб`}
        className={styles.previewZone}
      />
      <img
        className={styles.preview}
        src={
          form.values.previewFile
            ? URL.createObjectURL(form.values.previewFile)
            : ''
        }
        alt="preview"
      />
      <div className={styles.actions}>
        <Button type="submit">Сохранить</Button>
        <Button variant="light" onClick={() => history.back()}>
          Отменить
        </Button>
      </div>
    </form>
  );
};

export default CreateCategoryPage;
